module.exports = __webpack_public_path__ + "img/message.24b6ed91.svg";